/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectPatternPathStagesQuery } from '../../models/get-project-pattern-path-stages-query';
import { GetProjectPatternPathStagesQueryResult } from '../../models/get-project-pattern-path-stages-query-result';

export interface ApiProjectStagesGetPathStagesPost$Params {
      body?: GetProjectPatternPathStagesQuery
}

export function apiProjectStagesGetPathStagesPost(http: HttpClient, rootUrl: string, params?: ApiProjectStagesGetPathStagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathStagesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetPathStagesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectPatternPathStagesQueryResult>;
    })
  );
}

apiProjectStagesGetPathStagesPost.PATH = '/api/ProjectStages/GetPathStages';
